import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";

const PLACEHOLDER_HEADER_VALUE = "--";

export const ADDITIONAL_API_HEADERS_FOR_FGS_APIS = {
    CLIENT_ID: "portal",
    CAMPAIGN_NAME: "lpg",
};

export function getGandalfApiHeaders(): Record<string, string> {
    const headers = GlobalHeaderState.getHeaders() as Record<string, string>;
    const deviceId = headers[SwgyHeaderKeysList.deviceId] ?? PLACEHOLDER_HEADER_VALUE;

    return {
        "Content-Type": "application/json",
        "x-oztok": headers["x-oztok"] ?? PLACEHOLDER_HEADER_VALUE,
        swuid: headers[SwgyHeaderKeysList.swuid] ?? PLACEHOLDER_HEADER_VALUE,
        "app-version": headers[SwgyHeaderKeysList.appVersion] ?? PLACEHOLDER_HEADER_VALUE,
        tid: headers[SwgyHeaderKeysList.tid] ?? PLACEHOLDER_HEADER_VALUE,
        sid: headers[SwgyHeaderKeysList.sid] ?? PLACEHOLDER_HEADER_VALUE,
        token: headers[SwgyHeaderKeysList.token] ?? PLACEHOLDER_HEADER_VALUE,
        platform: headers[SwgyHeaderKeysList.platform] ?? PLACEHOLDER_HEADER_VALUE,
        versionCode: headers[SwgyHeaderKeysList.versionCode] ?? PLACEHOLDER_HEADER_VALUE,
        deviceid: deviceId,
        deviceId,
        "user-agent": headers[SwgyHeaderKeysList.userAgent] ?? PLACEHOLDER_HEADER_VALUE,
        latitude: headers[SwgyHeaderKeysList.lat] ?? PLACEHOLDER_HEADER_VALUE,
        longitude: headers[SwgyHeaderKeysList.lng] ?? PLACEHOLDER_HEADER_VALUE,
        "x-channel": headers[SwgyHeaderKeysList.xChannel] ?? PLACEHOLDER_HEADER_VALUE,
        "client-id": ADDITIONAL_API_HEADERS_FOR_FGS_APIS.CLIENT_ID,
        "campaign-name": ADDITIONAL_API_HEADERS_FOR_FGS_APIS.CAMPAIGN_NAME,
    };
}
